import request from "@/utils/request"

/**
 *
 * @returns {Object} fetched categories response object
 */
export function fetchCategories(params = {}) {
  return request({
    url: "/api/categories",
    method: "get",
    params
  })
}

/**
 * @param {Number} id - id to fetch category with
 * @returns {Object} fetched category response object
 */
export function fetchSingleCategory(id) {
  return request({
    url: "/api/categories/" + id,
    method: "get"
  })
}

/**
 *
 * creates a new category
 * @param {Object} params - request params
 * @param {Object} params - request params
 * @returns {Object} created category response object
 */
export function createCategory(params, data) {
  return request({
    url: "/api/categories",
    method: "post",
    params,
    data
  })
}

/**
 *
 * updates a category
 * @param {Object} id - category id to update
 * @param {Object} params - request params
 * @param {Object} data - request data
 * @returns {Object} created category response object
 */
export function updateCategory(id, params, data) {
  return request({
    url: "/api/categories/" + id,
    method: "put",
    params,
    data
  })
}

/**
 *
 * deletes category from database
 * @param {Object} id - category id to delete
 * @returns {Object} created category response object
 */
export function deleteCategory(id) {
  return request({
    url: "/api/categories/" + id,
    method: "delete"
  })
}
